import http from '../../../Utils/http';
import { buildCostBreakdownEmailBody } from '../../../Pages/Advertiser/Campaigns/ViewAdsCampaign/CostBreakdown/emailReportApi';

const CostBreakdownEmail = {
  name: 'CostBreakdownEmail',
  state: {
    sending: false,
    error: '',
  },
  reducers: {
    sendStart(state) {
      return { ...state, sending: true, error: '' };
    },
    sendDone(state) {
      return { ...state, sending: false, error: '' };
    },
    sendFailed(state, payload) {
      return { ...state, sending: false, error: typeof payload === 'string' ? payload : '' };
    },
    reset(state) {
      return { ...state, sending: false, error: '' };
    },
  },
  effects: () => ({
    async send({ campaignId, reportType, reportFormat, headers, rows }) {
      if (!campaignId) {
        const msg = 'Missing campaign id';
        this.sendFailed(msg);
        throw new Error(msg);
      }
      this.sendStart();
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
        const userId = userInfo?.id;
        let url = `savvy/campaigns/${campaignId}/cost-breakdown/email`;
        if (userId != null && String(userId).trim() !== '') {
          url += `?user_id=${encodeURIComponent(String(userId))}`;
        }
        const body = buildCostBreakdownEmailBody({
          campaignId,
          reportType,
          reportFormat,
          headers,
          rows,
        });
        await http.post(url, body);
        this.sendDone();
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || 'Failed to send email';
        this.sendFailed(msg);
        throw err;
      }
    },
  }),
};

export default CostBreakdownEmail;
